import { type AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

export type GetAuditEventsRequest = {
	skip: number
	take: number
	fromDate: string | undefined
	toDate: string | undefined
	userFilter: string
	typeFilter: string
	searchFilter?: string
	patientConditionIdFilter?: number
}

export type AuditEvent = {
	auditEventId: number
	content: any
	contentType: string
	tenantCodeName: string
	createdBy: string
	createdOn: string
}

export class AuditQueryClient {
	constructor(private axiosClient: AxiosInstance) {}

	public getAuditEvents = (body: GetAuditEventsRequest) => {
		body = {
			...body,
			fromDate: body.fromDate || undefined,
			toDate: body.toDate || undefined,
			searchFilter: body.searchFilter || undefined,
			patientConditionIdFilter: body.patientConditionIdFilter || undefined
		}
		return handleQueryResult(
			this.axiosClient.post<{
				data: AuditEvent[]
				total: number
			}>(`/api/admin/audit`, body)
		)
	}

	public getAuditTypes = () =>
		handleQueryResult(
			this.axiosClient.get<{ types: string[] }>(`/api/admin/audit/types`)
		)
}
